<template>
  <div class="apply">
    <div class="box-card">
      <div class="run">
        <p class="title">
          <span>
            <el-button @click="addNew()">{{ $t('person.group.button1') }}</el-button></span
          >
        </p>

        <div class="runTab">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="{
              background: '#006FB8',
              color: 'rgba(255, 255, 255, 0.85)',
              borderradius: '4px 4px 0px 0px',
            }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" :label="$t('person.group.tableLabel.name')" align="center" :selectable="checkSelectable"></el-table-column>
            <el-table-column prop="name" :label="$t('person.group.tableLabel.name')" align="center">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.name.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.name)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="column14" :label="$t('person.group.tableLabel.type')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.column14.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.column14)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="column15" :label="$t('person.group.tableLabel.number')" width="170">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.column15.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.column15)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="unitName" :label="$t('person.group.tableLabel.unitName')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.unitName.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.unitName)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="unitAddress" :label="$t('person.group.tableLabel.unitAddress')" align="center" width="170"> </el-table-column>
            <el-table-column prop="duty" :label="$t('person.group.tableLabel.duty')"> </el-table-column>
            <el-table-column prop="linkTelephone" :label="$t('person.group.tableLabel.phone')">
              <template slot-scope="scope">
                <span
                  :style="{
                    color: scope.row.linkTelephone.includes('[') ? '#FF190C' : '#333',
                  }"
                  v-html="split(scope.row.linkTelephone)"
                >
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="email" :label="$t('person.group.tableLabel.email')" :rules="rules.email" width="170">
              <template slot-scope="scope">
                <div
                  :style="{
                    color: matchEmail(scope.row.email) === false ? '#FF190C' : '#333',
                  }"
                >
                  {{ scope.row.email }}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="isSubmit" :label="$t('person.group.tableLabel.status')">
              <template slot-scope="scope">
                {{ scope.row.isSubmit | format }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('common.option')" width="155">
              <template slot-scope="scope">
                <el-button type="text" class="edit" @click="openEdit(scope.row)"
                  ><i class="el-icon-edit-outline">{{ $t('common.edit') }}</i></el-button
                >
                <el-button type="text" @click="deletMsg(scope.row.id)"
                  ><i class="el-icon-delete">{{ $t('common.cancel') }}</i></el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="download">
          <div class="item">
            <p>
              {{ $t('person.group.tip1')
              }}<span class="template"
                ><a href="./团队注册模板.xlsx" :download="$t('person.group.downloadFileName')">{{ $t('person.group.downloadText') }}</a></span
              >
            </p>
            <p>
              <el-upload
                class="upload-demo"
                :action="uploadExUrl"
                :headers="getToken()"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handSuccess"
              >
                <el-button>{{ $t('person.group.uploadText') }}</el-button>
              </el-upload>
            </p>
          </div>
          <div class="item sumit">
            <el-button type="primary" @click="submitVerify()">{{ $t('common.submit') }}</el-button>
            <span>{{ $t('person.group.tip2') }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑弹框开始 -->
    <div class="editMsg">
      <el-dialog :visible.sync="editVisible" width="30%" center :close-on-click-modal="false">
        <span slot="title" class="dialog-footer"> {{ $t('person.group.button2') }} </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form :model="editContent" ref="editContent" label-width="145px" :rules="rules">
              <el-form-item :label="$t('person.group.tableLabel.name')" prop="name">
                <el-input
                  v-model="editContent.name"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.name')"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.unitName')" prop="unitName">
                <el-input
                  v-model="editContent.unitName"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.unitName')"
                  maxlength="50"
                  show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.unitAddress')" prop="unitAddress">
                <el-input
                  v-model="editContent.unitAddress"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.unitAddress')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.type')" prop="column14">
                <el-select v-model="editContent.column14" :placeholder="$t('person.group.placeholders.type')" style="width: 100%">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.number')" prop="column15">
                <el-input v-model="editContent.column15" autocomplete="off" :placeholder="$t('person.group.placeholders.number')" maxlength="100"></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.phoneNumber')" prop="linkTelephone">
                <el-input
                  v-model="editContent.linkTelephone"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.phoneNumber')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.email')" prop="email">
                <el-input
                  type="age"
                  v-model="editContent.email"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.email')"
                  maxlength="100"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.duty')" prop="duty">
                <el-input style="width: 100%" v-model="editContent.duty" :placeholder="$t('person.group.placeholders.duty')"></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button @click="saveVerfiy()">{{ $t('common.save') }}</el-button></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 编辑弹框结束 -->

    <!-- 新增弹框开始 -->
    <div class="editMsg">
      <el-dialog :visible.sync="saveVisible" width="30%" center :close-on-click-modal="false" @click="closeDialog" :destroy-on-close="true">
        <span slot="title" class="dialog-footer"> {{ $t('person.group.button3') }} </span>

        <!--  表单开始 -->
        <div class="instance">
          <div class="content">
            <el-form :model="saveContent" ref="formName" label-width="145px" :rules="rules">
              <el-form-item :label="$t('person.group.tableLabel.name')" prop="name">
                <el-input
                  type="age"
                  v-model="saveContent.name"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.name')"
                  maxlength="50"
                  show-word-limit
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.unitName')" prop="unitName">
                <el-input
                  type="age"
                  v-model="saveContent.unitName"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.unitName')"
                  maxlength="50"
                  show-word-limit
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.unitAddress')" prop="unitAddress">
                <el-input
                  type="age"
                  v-model="saveContent.unitAddress"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.unitAddress')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.type')" prop="column14">
                <el-select v-model="saveContent.column14" :placeholder="$t('person.group.placeholders.type')" style="width: 100%">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.number')" prop="column15">
                <el-input
                  type="age"
                  v-model="saveContent.column15"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.number')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.phoneNumber')" prop="linkTelephone">
                <el-input
                  type="age"
                  v-model="saveContent.linkTelephone"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.phoneNumber')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.email')" prop="email">
                <el-input
                  type="age"
                  v-model="saveContent.email"
                  autocomplete="off"
                  :placeholder="$t('person.group.placeholders.email')"
                  maxlength="100"
                  :validate-event="false"
                ></el-input>
              </el-form-item>

              <el-form-item :label="$t('person.group.tableLabel.duty')" prop="duty">
                <el-input style="width: 100%" v-model="saveContent.duty" :placeholder="$t('person.group.placeholders.duty')"></el-input>
              </el-form-item>

              <el-row class="save"
                ><el-button @click="sumitAdd('formName')">{{ $t('common.save') }}</el-button></el-row
              >
            </el-form>
          </div>
        </div>
        <!--  表单结束 -->
      </el-dialog>
    </div>
    <!-- 新增弹框结束 -->
  </div>
</template>
<script>
import { getteamList, addteamuser, getOnedata, editItem, dleteItem, uploadItem } from '../../../../api/tuanyuan';
import { uploadExcelUrl } from '../../../../utils/common';
import { auth } from '../../../../api/common.js';
import VueI18n from 'vue-i18n';

export default {
  data() {
    var validatecolumn15 = (rule, value, callback) => {
      let type ;
        if(this.editId){
          type =  this.editContent.column14;
        }else {
          type = this.saveContent.column14
        }
      if (!type) {
        callback(new Error(this.$t('person.group.rules.errors.type')));
      }
      if (type === this.$t('person.group.options.label1')) {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value) === false) {
          callback(new Error(this.$t('person.group.rules.errors.type1')));
        }
      }

      callback();
    };

    var validatorPhone = (rule, value, callback) => {
      const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (reg.test(value) === false) {
        callback(new Error(this.$t('person.group.rules.errors.phone')));
      }
      callback();
    };

    var validatorEmail = (rule, value, callback) => {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (reg.test(value) === false) {
        callback(new Error(this.$t('person.group.rules.errors.email')));
      }
      callback();
    };

    return {
      uploadExUrl: uploadExcelUrl(),
      rules: {
        name: [{ required: true, message: this.$t('person.group.rules.require.name') }],
        unitName: [{ required: true, message: this.$t('person.group.rules.require.unitName') }],
        // unitAddress: [{ required: true, message: '单位地址不能为空' }],
        column14: [{ required: true, message: this.$t('person.group.rules.require.type') }],
        column15: [{ required: true, message: this.$t('person.group.rules.require.number') }, { validator: validatecolumn15 }],
        linkTelephone: [{ required: true, message: this.$t('common.rules.phone') }, { validator: validatorPhone }],
        email: [{ required: true, message: this.$t('common.rules.email') }, { validator: validatorEmail }],
      },
      options: [
        {
          value: this.$t('person.group.options.label1'),
          label: this.$t('person.group.options.label1'),
        },
        {
          value: this.$t('person.group.options.label2'),
          label: this.$t('person.group.options.label2'),
        },
        {
          value: this.$t('person.group.options.label3'),
          label: this.$t('person.group.options.label3'),
        },
        {
          value: this.$t('person.group.options.label4'),
          label: this.$t('person.group.options.label4'),
        },
      ],
      // 判断当前参展人员的状态
      // flag: '',
      //文件上传下载
      fileList: [],

      tableData: [],

      //编辑弹框标志位
      editVisible: false,
      //编辑弹框的具体内容
      editContent: {
        name: '', //姓名
        unitName: '', //单位名称
        unitAddress: '', //单位地址
        column14: '', //证件类型
        column15: '', //证件号
        duty: '', //职务
        linkTelephone: '', //手机号
        email: '', //邮箱
      },
      //保存弹框的具体内容
      saveVisible: false,
      //保存弹框的具体内容
      saveContent: {
        name: '', //姓名
        unitName: '', //单位名称
        unitAddress: '', //单位地址
        column14: '', //证件类型
        column15: '', //证件号
        duty: '', //职务
        linkTelephone: '', //手机号
        email: '', //邮箱
      },
      //登记窗口关闭提示信息
      msgVisible: false,
      //超出份额提示
      overflowVisible: false,
      editId: '',
      currentSelectLists: [],
    };
  },
  methods: {
    split(current) {
      if (current.includes('[')) {
        const arr = current.split('[');
        const result = arr[0] + '<br>' + arr[1].substr(0, arr[1].length - 1);
        return result;
      } else {
        return current;
      }
    },
    matchEmail(email) {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (reg.test(email) === false) {
        //邮箱不合格
        return false;
      } else {
        return true;
      }
    },
    getToken() {
      const a = localStorage.getItem('viewToken');
      let token = {};
      token.token = a;
      return token;
    },
    handSuccess(file) {
      // 上传excel文件成功函数
      if (file.code == 200) {
        // 文件上传成功
        this.$message({
          message: this.$t('person.group.messages.excel'),
          type: 'success',
        });
        this.getAllList();
      }
    },
    handleSelectionChange(selection) {
      this.currentSelectLists = selection;
    },
    checkSelectable(row) {
      return row.auditFlag === '-1' || row.isSubmit === 1;
    },
    //提交参展人员审核函数
    async submitVerify() {
      const arr = [];
      this.currentSelectLists.map((item) => {
        arr.push(item.id);
      });
      try {
        const { data } = await uploadItem(arr);
        if (data.code === 200) {
          this.$message({
            message: this.$t('person.group.messages.submit'),
            type: 'success',
          });
          this.getAllList();
        }
      } catch (err) {}
    },
    //文件上传移除相关钩子函数
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `${this.$t('person.group.messages.limit.tip1')} ${files.length} ${this.$t('person.group.messages.limit.tip2')}  ${files.length +
          fileList.length} ${this.$t('person.group.messages.limit.tip3')}`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`${this.$t('person.group.messages.confirm.tip1')} ${file.name}${this.$t('person.group.messages.confirm.tip2')}`);
    },
    //编辑弹框相关函数
    //打开编辑框
    async openEdit(row) {
      this.editVisible = true;
      this.editId = row.id;
      const params = { id: row.id };
      try {
        const { data } = await getOnedata(params);
        if (data.code === 200) {
          this.editContent = data.data;
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    // 表单验证
    saveVerfiy() {
      this.$refs.editContent.validate((valid) => {
        if (valid) {
          this.idAuth1(); //执行提交操作
        } else {
          return false;
        }
      });
    },

    //编辑保存函数
    async saveMsg() {
      const params = this.editContent;
      params.id = this.editId;
      try {
        const { data } = await editItem(params);
        if (data.code === 200) {
          this.editVisible = false;
          this.$message({
            message: this.$t('person.group.messages.edit'),
            type: 'success',
          });
          this.getAllList();
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
    //表格数据删除
    async deletMsg(id) {
      const params = { id: id };
      this.$confirm(this.$t('person.group.messages.cancel.text'), this.$t('person.group.messages.cancel.title'), {
        confirmButtonText: this.$t('person.group.messages.cancel.confirmText'),
        cancelButtonText: this.$t('person.group.messages.cancel.cancelText'),
        customClass: 'myClass',
      }).then(async () => {
        const { data } = await dleteItem(params);
        if (data.code === 200) {
          this.$message({
            message: this.$t('person.group.messages.cancelSuccess'),
            type: 'success',
          });
          this.getAllList();
        }
      });
    },
    //打开新增弹框
    addNew() {
      this.saveContent = { column14: this.$t('person.group.options.label1') };
      this.saveVisible = true;
    },
    //保存操作
    async save1() {
      try {
        const { data } = await addteamuser(this.saveContent);
        if (data.code === 200) {
          this.$message({
            message: this.$t('person.group.messages.addSuccess'),
            type: 'success',
          });
          this.saveVisible = false;
          this.getAllList();
        }
      } catch (err) {
        this.$message.error(this.$t('person.group.messages.addFail'));
      }
    },
    //保存
    sumitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.idAuth(); //执行提交操作
        } else {
          return false;
        }
      });
    },

    // 身份认证函数
    async idAuth() {
      const params = {
        name: this.saveContent.name,
        idCard: this.saveContent.column15,
      };

      if (this.saveContent.column14 == this.$t('person.group.options.label1')) {
        try {
          const { data } = await auth(params);
          if (data.code === 200) {
            this.save1();
          } else {
            this.saveContent.column15 = '';
            this.$message.error(this.$t('person.group.rules.errors.authFail'));
          }
        } catch (err) {}
      } else {
        this.save1();
      }
    },

    // 身份认证函数save1
    async idAuth1() {
      const params = {
        name: this.editContent.name,
        idCard: this.editContent.column15,
      };

      if (this.saveContent.column14 == this.$t('person.group.options.label1')) {
        try {
          const { data } = await auth(params);
          if (data.code === 200) {
            this.saveMsg();
          } else {
            // this.editContent.column15 = ''
            this.$message.error(this.$t('person.group.rules.errors.authFail'));
          }
        } catch (err) {}
      } else {
        this.saveMsg();
      }
    },

    // 获取列表
    async getAllList() {
      try {
        const { data } = await getteamList();
        this.tableData = data.data.list;
      } catch (err) {
        this.$message.error(err);
      }
    },
    closeDialog() {
      this.$refs.saveContent.resetFields();
    },
  },
  filters: {
    format(value) {
      const i18n = new VueI18n({
        locale: localStorage.getItem('lang') || 'zh',
        messages: {
          zh: require('../../../assets/i18n/zh'),
          en: require('../../../assets/i18n/en'),
        },
        silentTranslationWarn: true,
      });
      if (value == 1) {
        return i18n.t('person.group.noSubmit');
      } else {
        return i18n.t('person.group.submited');
      }
    },
  },
  created() {
    this.getAllList();
  },
};
</script>

<style scoped lang="scss">
.apply {
  // padding: 17px 26px;
  box-sizing: border-box;
  background: #fff;
  min-height: 694px;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 560;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
      padding-bottom: 9px;
      background: #f6f6f7;
      .txt {
        padding-left: 65px;
        box-sizing: border-box;
        position: relative;
        padding-top: 9px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .shuoMing {
          position: absolute;
          top: 9px;
          left: 26px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff190c;
        }
        .telNumber {
          color: #006fb8;
        }
      }
    }
    .instance {
      margin: 35px 17px 0px 17px;

      .distribution {
        .title {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 9px;
          border-bottom: 1px solid #e9e9e9;
        }
        .tab {
          margin-top: 9px;
          table {
            border-collapse: collapse;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            border-radius: 3px 3px 0px 0px;
            height: 36px;
            width: 100%;
            tbody {
              border: 1px solid #e8e8e8;
              .thead {
                height: 36px;
                background: #006fb8;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.85);
                line-height: 19px;
                .notice {
                  text-align: left;
                  padding-left: 45px;
                }
              }
              .tbody {
                .number {
                  border: 1px solid #e8e8e8;
                  height: 60px;
                  width: 120px;
                }
                .txt {
                  padding: 0px 85px;
                  box-sizing: border-box;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                }
                .beizhu {
                  padding: 0px 45px;
                  font-size: 14px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
    .run {
      margin: 5px 17px 0px 17px;

      .title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        padding-bottom: 9px;
        display: flex;
        justify-content: flex-end;
        .el-button {
          // width: 100px;
          height: 28px;
          line-height: 0px;
          padding: 5px;
          box-sizing: border-box;
          position: relative;
          top: 3px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .runTab {
        margin-top: 10px;
        width: 100%;
      }
      .download {
        .item {
          margin-top: 17px;
          display: flex;
          justify-content: flex-start;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;

          p {
            line-height: 28px;
          }
          .upload-demo {
            margin-left: 52px;
          }
          .template {
            a {
              color: #006fb8;
            }
          }
        }
      }
    }
  }
  .editMsg {
    //编辑框的弹框信息
    .dialog-footer {
      width: 100%;
      position: relative;
      top: -5px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      width: 150px;
      //标题
      .instance {
        margin: 0px 17px 0px 17px;
        .title {
          padding: 35px 0px 9px 0px;
          border-bottom: 1px solid #e9e9e9;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .txt {
          margin-top: 17px;
          padding-left: 65px;
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          height: 36px;
          background: #f6f6f7;
          .shuoMing {
            position: absolute;
            top: 9px;
            left: 26px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
          }
        }
        .content {
          width: 50%;
          margin: 0 auto;
          margin-top: 35px;
          position: relative;
          left: -40px;
          .telNumber {
            color: #006fb8;
            margin-left: 5px;
          }
          .numberV {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 19px;
            letter-spacing: 1px;
            .remaining {
              color: #ff190c;
            }
          }
        }
        //展品信息分类
        .box {
          width: 60%;
          position: relative;
          left: 161px;
          //每一项开始
          .item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .left {
              width: 107px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 19px;
              text-align: right;
              padding-right: 17px;
              padding-top: 10px;
              box-sizing: border-box;
            }
            .right {
              flex: 1;
              position: relative;
              .twoTitle {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .folding {
                position: absolute;
                right: 30px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
              }
            }
          }

          //每一项结束
        }
        .bottom {
          width: 60%;
          position: relative;
          left: 161px;
          .btn {
            margin-top: 22px;
            margin-bottom: 30px;
            .why {
              margin-left: 120px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff190c;
              margin-bottom: 22px;
              a {
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #006fb8;
              }
            }
          }
        }
      }
    }
  }

  .noticeMsg {
    //编辑框的弹框信息

    .dialog-footer {
      height: 36px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: left;
    }
    .content {
      border-bottom: 1px solid #00000017;
      padding-bottom: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      span {
        color: #006fb8;
        padding-left: 5px;
      }
    }
    .sure {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
    }
  }
}
</style>
<style scoped>
.el-table >>> th {
  padding: 0px !important;
  height: 36px;
}
.upload-demo >>> .el-button {
  height: 28px !important;
  padding: 5px;
  box-sizing: border-box;
}
.sumit >>> .el-button {
  margin-top: 10px;
  width: 76px;
  height: 28px;
  background: #006fb8;
  padding: 0px;
  margin-bottom: 163px;
}
.sumit span {
  height: 26px;
  line-height: 26px;
  padding: 10px;
  box-sizing: border-box;
  color: red;
}

[class*=' el-icon-'],
[class^='el-icon-'] {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #006fb8;
  line-height: 20px;
  margin: 0px 8px;
}
.edit {
  border-right: 1px solid #e9e9e9;
}

.runTab >>> .el-button {
  padding: 0px;
  border-radius: 0px;
}

.runTab >>> .el-button + .el-button {
  margin-left: 0px;
}
.el-dialog__wrapper >>> .el-dialog__header {
  background: #006fb8;
  display: flex;
  justify-content: space-between;
}
.save {
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: flex-end;
}
.save >>> .el-button {
  padding: 0px;
  width: 30%;
  height: 35px;
  text-align: center;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.sure {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
.sure >>> .el-button {
  padding: 0px;
  width: 65px;
  height: 32px;
  background: #006fb8;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.noticeMsg >>> .el-dialog__body {
  padding-bottom: 10px;
}
.apply >>> .el-dialog__close {
  color: #ffffff;
}
</style>
